export default "__VITE_ASSET__C29KNQZ4__"